<template>
  <div>
    <div class="modal-content-generic">
      <div class="content lh-loose">
        <p>
          {{ data.booking_type_label }} schedule and location will become available 24 hours before your booking time.
        </p>
      </div>
    </div>
    <div class="modal-actions">
      <div class="action">
        <button type="button" class="button primary" @click="confirm">
          <span>Okay</span>
          <svg-icon id="chevronRight"></svg-icon>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import BaseModal from '../../Base'

export default {
  extends: BaseModal,
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  methods: {
    confirm () {
      this.$emit('confirm')
    }
  }
}
</script>
